export default __webpack_public_path__ + "media/images/front/municipality_collaboration/fukushima/ogp-26430b0f38b7b758efa8d70d0dbabc63.png";